export default "__VITE_ASSET__uV1MO_XQ__"